import { useEffect, useState } from "react";

const useApplePay = () => {
  const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    
    setIsApplePayAvailable(window.ApplePaySession && window.ApplePaySession.canMakePayments());
  }, []);

  return isApplePayAvailable;
}

export default useApplePay;